// Tells buildRefresh.js whether it's safe to auto-reload the app: never
// interrupt a merchant mid-sale. Two cart implementations exist — the
// online-POS cart (UserSideContext) which is persisted to localStorage under
// "cart", and the offline-POS cart (OfflinePOSContext) which only lives in
// React state — so the offline side mirrors its size here on every change.
let offlineCartSize = 0;

export const setOfflineCartActivity = (size) => {
  offlineCartSize = size || 0;
};

export const hasActiveCartActivity = () => {
  if (offlineCartSize > 0) return true;
  try {
    const raw = localStorage.getItem("cart");
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.length > 0 : Boolean(parsed);
  } catch (e) {
    return true; // unreadable cart state — fail safe, don't auto-reload
  }
};
